export default {
  GET_ASSOCIATED_PRODUCT_QUERY: Symbol.for('GET_ASSOCIATED_PRODUCT_QUERY'),
  ASSOCIATED_PRODUCT_REPOSITORY: Symbol.for('ASSOCIATED_PRODUCT_REPOSITORY'),
  ASSOCIATED_PRODUCT_STATE_MANAGER: Symbol.for('ASSOCIATED_PRODUCT_STATE_MANAGER'),
  GET_INTEREST_RATE_BY_FIXED_TYME_SERVICE: Symbol.for('GET_INTEREST_RATE_BY_FIXED_TYME_SERVICE'),
};
